/**
 * Anyone with an explicit B2B role lands on Cohorts B2B, including Admin + B2B.
 * Admin-only (no B2B claim) keeps the default Cohorts B2C landing.
 *
 * Admin and B2B are independent Keycloak role claims (`role:admin`, `role:b2b`);
 * having Admin does not imply B2B in the token.
 */
export const preferCohortsB2bLanding = (authServer) =>
  authServer.isRoles(['b2b']);
